import { CognitoUserSession } from 'amazon-cognito-identity-js';

import LocalStorage from 'utils/cognito/storage';
import { StorageKeys } from 'utils/local-storage';

import { getCurrentCognitoUser } from './util';

const clearUserSessionFromLocalStorage = () => {
  LocalStorage.setItem(StorageKeys.USER, null);
  LocalStorage.removeItem(StorageKeys.USER_SIGNED_IN_SUCCESSFULLY);
};

// return the current user session
export const getCurrentSession = (): Promise<CognitoUserSession | null> => {
  return new Promise(resolve => {
    const cognitoUser = getCurrentCognitoUser();

    if (cognitoUser) {
      cognitoUser.getSession((err: Error | null, session: CognitoUserSession) => {
        if (err || !session.isValid()) {
          // Clear local storage to prevent a user with no session from being "logged in"
          clearUserSessionFromLocalStorage();
          resolve(null);
        } else {
          resolve(session);
        }
      });
    } else {
      // No current user found, clear local storage
      clearUserSessionFromLocalStorage();
      resolve(null);
    }
  });
};
